import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Settings from './Settings';
import configService from '../services/configService';

const AdminSettings = () => {
  const { userId } = useParams(); // cognito_user_id of the customer being edited
  const navigate = useNavigate();
  const [businessName, setBusinessName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('[AdminSettings] Customer cognito_user_id from URL:', userId);
    console.log('[AdminSettings] Current URL:', window.location.href);
    loadBusinessName();
  }, [userId]);

  const loadBusinessName = async () => {
    try {
      console.log('[AdminSettings] Loading config for customer cognito_user_id:', userId);
      const config = await configService.getAdminUserConfig(userId);
      console.log('[AdminSettings] Loaded customer config:', {
        customer_cognito_user_id: userId,
        business_id: config.business_id,
        business_name: config.business_name
      });
      setBusinessName(config.business_name || userId);
    } catch (err) {
      console.error('[AdminSettings] Error loading config:', err);
      setBusinessName(userId);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
    </div>;
  }

  return (
    <div>
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <i className="fas fa-user-shield text-yellow-700 mr-3"></i>
            <p className="text-yellow-700 font-medium">
              Admin Mode: Editing configuration for <span className="font-bold">{businessName}</span>
            </p>
          </div>
          <button
            onClick={() => navigate('/admin/customers')}
            className="text-gray-600 hover:text-gray-800 bg-transparent border-none cursor-pointer text-sm"
          >
            ← Back to Customer List
          </button>
        </div>
      </div>
      
      <Settings adminBusinessId={userId} />
    </div>
  );
};

export default AdminSettings;
